export default __webpack_public_path__ + "static/media/body-tracking-sdk.1ccfcb6c.jpg";